export default __webpack_public_path__ + "static/media/page-loader.d1bac885.gif";